import { Box, Typography } from "@mui/material";
import React from "react";
import { PlayButton } from "../components/Icons";
import { learnAboutUsItems } from "../utils/data";

const LearnAboutTrialPartners = () => {
  const img = require("../assets/Rectangle1.png");
  return (
    <Box className="grid grid-cols-3 p-4 gap-5 ">
      {learnAboutUsItems.map((item) => (
        <Box className="flex-column p-4 gap-4 rounded-xl border border-primary-blue-100 bg-white">
          <Typography className="!text-base !font-medium">
            {item.title}
          </Typography>
          <Box className="relative">
            <img
              src={item.thumbnail}
              alt="thumbnail"
              className="w-[466px] h-[200px] rounded-[10px]"
            />
            <Box className=" flex-center cursor-pointer p-[7px] rounded absolute top-[35%] right-[40%]">
              <PlayButton />
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default LearnAboutTrialPartners;
